/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonButton from "components/ArgonButton";

import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

import { Link } from "react-router-dom";

const ProductEnqTableData = (productEnqs, handleDeleteClick, refreshData) => ({
  columns: [
    { name: "sno", align: "center" },
    { name: "User Name", align: "left" },
    { name: "Product Name", align: "left" },
    { name: "Image Banner", align: "left" },
    { name: "Price Normal", align: "center" },
    { name: "Discount Price", align: "center" },
    { name: "Action", align: "center" },
  ],

  rows: productEnqs.map((enq, index) => ({
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {index + 1}
      </ArgonTypography>
    ),
    "User Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {enq.userName || "N/A"}
      </ArgonTypography>
    ),
    "Product Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {enq.productName || "N/A"}
      </ArgonTypography>
    ),
    "Image Banner": (
      <ArgonAvatar
        src={enq.imageBanner}
        alt={enq.productName || "Product"}
        size="sm"
        variant="rounded"
      />
    ),
    "Price Normal": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        ₹{enq.priceNormal || 0}
      </ArgonTypography>
    ),
    "Discount Price": (
      <ArgonTypography variant="caption" color="success" fontWeight="medium">
        ₹{enq.discountPrice || 0}
      </ArgonTypography>
    ),
    Action: (
      <ArgonBox display="flex" alignItems="center" gap={0}>
        {/* View Icon */}
        <ArgonButton
          variant="text"
          size="large"
          sx={{ minWidth: "32px", p: 0 }}
          component={Link}
          to={`/product/viewproductenq/${enq._id}`}
        >
          <VisibilityIcon color="primary" />
        </ArgonButton>
        {/* Delete Icon */}
        <ArgonButton
          variant="text"
          size="large"
          sx={{ minWidth: "32px", p: 0 }}
          onClick={() => handleDeleteClick(enq._id)}
        >
          <DeleteIcon color="error" />
        </ArgonButton>
      </ArgonBox>
    ),
  })),
});

export default ProductEnqTableData;
